// ============================================================================
// GUEST ENDPOINTS
// ============================================================================
// API endpoint definitions for Guest module

import { buildEndpoint } from './base.endpoints';
import type { ID } from '../types/common.types';

const BASE_PATH = '/Guest';

export const guestEndpoints = {
  /** GET /Guest — list all (paginated) */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /Guest/{id} — get by ID */
  getById: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** GET /Guest/email/{email} — get by email */
  getByEmail: (email: string) => buildEndpoint(`${BASE_PATH}/email/${email}`),

  /** POST /Guest — create */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /Guest/{id} — update */
  update: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** DELETE /Guest/{id} — delete */
  delete: (id: ID) => buildEndpoint(`${BASE_PATH}/${id}`),

  /** GET /Guest/validate/email/{email} — validate email uniqueness */
  validateEmail: (email: string) => buildEndpoint(`${BASE_PATH}/validate/email/${email}`),
};

export default guestEndpoints;
